import { collection, deleteDoc, doc, getDoc, setDoc, Timestamp, updateDoc, } from "firebase/firestore";
import { warnUnknownFields } from "./converterWarnings";
import { prepareForFirestore } from "./utils";
export const COMPANY_FIELDS = [
    "id",
    "path",
    "name",
    "customerType",
    "contactName",
    "contactEmail",
    "contactPhone",
    "timeZone",
    "retentionDays",
    "onboarding",
    "createdAt",
    "features",
    "updatedAt",
    "whatsappConnection",
    "sipSettings",
    "outboundCallerIds",
];
export const companyConverter = {
    toFirestore(value) {
        return prepareForFirestore(value);
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        warnUnknownFields("packages/ui Company.fromFirestore", data, COMPANY_FIELDS);
        return {
            id: snapshot.id,
            name: data.name || "",
            customerType: data.customerType === "paying" ||
                data.customerType === "trial" ||
                data.customerType === "test"
                ? data.customerType
                : data.customerType === null
                    ? null
                    : undefined,
            contactName: data.contactName || "",
            contactEmail: data.contactEmail || "",
            contactPhone: data.contactPhone || "",
            timeZone: typeof data.timeZone === "string" && data.timeZone.trim()
                ? data.timeZone
                : "Asia/Jerusalem",
            retentionDays: data.retentionDays === null
                ? null
                : Number.isInteger(data.retentionDays) && data.retentionDays > 0
                    ? data.retentionDays
                    : undefined,
            onboarding: data.onboarding,
            createdAt: data.createdAt instanceof Timestamp
                ? data.createdAt.toDate().toISOString()
                : data.createdAt || new Date().toISOString(),
            features: data.features || {},
            whatsappConnection: data.whatsappConnection?.status === "processing" ||
                data.whatsappConnection?.status === "connected" ||
                data.whatsappConnection?.status === "failed"
                ? { status: data.whatsappConnection.status }
                : undefined,
            sipSettings: data.sipSettings
                ? {
                    domainSid: data.sipSettings.domainSid || undefined,
                    domainName: data.sipSettings.domainName || undefined,
                    credentialListSid: data.sipSettings.credentialListSid || undefined,
                    sipUsernames: Array.isArray(data.sipSettings.sipUsernames)
                        ? data.sipSettings.sipUsernames.filter((u) => typeof u === "string" && u.trim().length > 0)
                        : undefined,
                }
                : undefined,
            outboundCallerIds: Array.isArray(data.outboundCallerIds)
                ? data.outboundCallerIds
                    .filter((item) => Boolean(item) &&
                    typeof item === "object" &&
                    typeof item.phoneNumber ===
                        "string" &&
                    (item.status === "verified" ||
                        item.status === "unverified"))
                    .map((item) => ({
                    phoneNumber: item.phoneNumber,
                    status: item.status,
                    twilioOutgoingCallerIdSid: typeof item.twilioOutgoingCallerIdSid === "string"
                        ? item.twilioOutgoingCallerIdSid
                        : null,
                }))
                : undefined,
        };
    },
};
export function companiesCollection(db) {
    return collection(db, "companies").withConverter(companyConverter);
}
export function companyDocument(db, companyId) {
    return doc(db, "companies", companyId).withConverter(companyConverter);
}
export async function fetchCompany(db, companyId) {
    const snapshot = await getDoc(companyDocument(db, companyId));
    return snapshot.exists() ? snapshot.data() : null;
}
export async function createCompany(db, data) {
    const docRef = doc(companiesCollection(db));
    await setDoc(docRef, {
        ...data,
        timeZone: data.timeZone || "Asia/Jerusalem",
        id: docRef.id,
        createdAt: new Date(),
    });
    return docRef.id;
}
export async function updateCompany(db, companyId, data) {
    const docRef = companyDocument(db, companyId);
    await updateDoc(docRef, data);
}
export async function deleteCompany(db, companyId) {
    await deleteDoc(companyDocument(db, companyId));
}
